var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39334 7.40753C4.39334 5.74219 5.74268 4.39286 7.40801 4.39153H8.78001C9.57601 4.39153 10.3387 4.07553 10.904 3.51553L11.8627 2.55553C13.0373 1.37419 14.9467 1.36886 16.128 2.54353L16.1293 2.54486L16.1413 2.55553L17.1013 3.51553C17.6667 4.07686 18.4293 4.39153 19.2253 4.39153H20.596C22.2613 4.39153 23.612 5.74086 23.612 7.40753V8.77686C23.612 9.57286 23.9267 10.3369 24.488 10.9022L25.448 11.8622C26.6293 13.0369 26.636 14.9462 25.4613 16.1275L25.46 16.1289L25.448 16.1409L24.488 17.1009C23.9267 17.6649 23.612 18.4275 23.612 19.2235V20.5955C23.612 22.2609 22.2627 23.6102 20.5973 23.6102H19.2227C18.4267 23.6102 17.6627 23.9262 17.0987 24.4875L16.1387 25.4462C14.9653 26.6275 13.0573 26.6342 11.876 25.4622C11.8747 25.4609 11.8733 25.4595 11.872 25.4582L11.86 25.4462L10.9013 24.4875C10.3373 23.9262 9.57334 23.6115 8.77734 23.6102H7.40801C5.74268 23.6102 4.39334 22.2609 4.39334 20.5955V19.2209C4.39334 18.4249 4.07734 17.6622 3.51601 17.0982L2.55734 16.1382C1.37601 14.9649 1.36934 13.0569 2.54268 11.8755C2.54268 11.8742 2.54401 11.8729 2.54534 11.8715L2.55734 11.8595L3.51601 10.8995C4.07734 10.3342 4.39334 9.57153 4.39334 8.77419V7.40753Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 13.9997L12.667 16.6663L18.0003 11.333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0eaecaaea1b8c715a9741c3c222b5f9c.svg";
export { ForwardRef as ReactComponent };